/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const roadmapAchievementDtoSchema = z.object({
  stage: z.optional(z.string()),
  evidenceType: z.optional(z.string()),
  signalStrength: z.optional(z.string()),
  meaning: z.optional(z.string()),
  detail: z.optional(z.string()),
});
